import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { AGENCY_LISTING_INIT_LOADING, AGENCY_LISTING_INIT_SUCCESS, AGENCY_LISTING_INIT_FAIL, AGENCY_QUOTATION_RESET, AGENCY_QUOTATION_LOAD_DATA } from '@/store/types'

export const list = {
  async agencyQuoteListInit({ commit, state }) {
    // reset quotation state (prevent dirty data)
    commit(AGENCY_QUOTATION_RESET)

    if (state.listing.init !== 1) {
      const apiUrl = state.menu.listing
      if (apiUrl) {
        commit(AGENCY_LISTING_INIT_LOADING)
        try {
          const result = await http.get(apiUrl)
          const menu = extractMenu(result.data._links)
          const commitResult = {
            menu: menu
          }
          commit(AGENCY_LISTING_INIT_SUCCESS, commitResult)
        } catch (error) {
          commit(AGENCY_LISTING_INIT_FAIL, extractMessages(error))
        }
      } else {
        commit(AGENCY_LISTING_INIT_FAIL, ['Invalid API URL'])
      }
    }
  },
  async loadQuote({ commit, state, rootState }, data) {
    if (rootState.app.menu.getProposal && data.proposalNo) {
      try {
        const expand = {
          proposalNo: data.proposalNo
        }
        const result = await http.get(expandURI(rootState.app.menu.getProposal, expand))
        if (result.data) {
          const menu = extractMenu(result.data._links)
          // data.query: to defined if its coming from query (some stuff for query are not defaulted)
          const commitResult = {
            partialSave: false,
            data: result.data,
            query: data.query,
            menu
          }
          commit(AGENCY_QUOTATION_LOAD_DATA, commitResult)
        } else {
          throw new Error('Invalid Fetch Result')
        }
      } catch (err) {
        throw err
      }
    } else {
      throw new Error('Invalid API URL')
    }
  }
}
